import type { NuxtUiTheme } from '../types/nuxt-ui-theme';
import { InputVariants } from '../../../../constants/input-variants';
import {
    selectTriggerStyles,
    selectValueStyles,
    selectPlaceholderStyles,
    selectContentStyles,
    selectViewportStyles,
    selectGroupLabelStyles,
    selectItemStyles,
    selectItemTrailingIconStyles,
    selectIndicatorIconStyles
} from '../shared-styles';

type SelectMenuTheme = NuxtUiTheme['selectMenu'] & {
    defaultVariants: { searchInput: { variant: typeof InputVariants.Neumorphic } };
};

export default {
    defaultVariants: {
        size: 'md',
        searchInput: { variant: InputVariants.Neumorphic }
    },
    variants: {
        variant: {
            neumorphic: {
                base: selectTriggerStyles,
                trailing: 'flex shrink-0 items-center',
                trailingIcon: selectIndicatorIconStyles,
                value: selectValueStyles,
                placeholder: selectPlaceholderStyles,
                arrow: selectIndicatorIconStyles,
                content: selectContentStyles,
                viewport: selectViewportStyles,
                group: 'py-2',
                label: selectGroupLabelStyles,
                separator: 'my-2 h-px bg-(--slate-muted-alpha-20)',
                item: selectItemStyles,
                itemLeadingIcon: 'size-5 shrink-0 text-(--text-light)',
                itemTrailingIcon: selectItemTrailingIconStyles,
                itemLabel: 'flex-1 text-current!',
                input: 'w-full border-0! p-1.5',
                focusScope: 'outline-none',
                trailingClear: 'cursor-pointer text-(--text-muted) transition-colors duration-200 hover:text-[#ef4444]'
            }
        }
    }
} satisfies SelectMenuTheme;
